module.exports = __webpack_public_path__ + "static/when_gray-27e32dc97d7d426e91a590c5fe350946.svg";